export const GLOBAL_SRC = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
//# sourceMappingURL=scriptSrc.js.map